// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3K8z4","messages":"Chat_messages__1dUcp","dateDivider":"Chat_dateDivider__v2muD"};